import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from './utils/sentry';
import App from './App';

// Initialize Sentry before rendering (no-op if VITE_SENTRY_DSN not set)
initSentry();

// Jay Swan startup banner
console.log(
  '%c' + [
    '                  ,-----.',
    '                ,-,-o-   `\\',
    '          __.--"`-,)       \\',
    '         `---------\'-.._    \\',
    '                        `.   :',
    '                         |   |',
    '                         |   |',
    '                         |   |',
    '                         ,   ;',
    '                        /    |        Deeliver Admin',
    "                       /    /                              /'|",
    '                      /     |    __,---,___________    /  /',
    "                     /     |    _,-'      ,         ,'_,-'  /",
    "                    /      \\_,-'        .'       ,-'       /",
    "                   (                , -'        -,        /",
    '                    \\                            ,       /',
    '                     \\            -  -   -  "           /',
    '       ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~',
  ].join('\n'),
  'color: #00bcd4; font-family: monospace;'
);
console.log(
  '%c🦢 Deeliver Admin Panel\n%c🌍 Environment: ' + import.meta.env.MODE + ' | ⚡ React 19 + React-Admin',
  'color: #4caf50; font-weight: bold; font-size: 14px;',
  'color: #888;'
);
console.log('='.repeat(70));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
